import type {Nullable} from '../utility-types';
import type {NaiveDateTimeObj} from './types';

import {datetimeObjToISOString} from './dateTimeObjToISOString';

export const naiveDateTimeObjToISOString = (
  obj?: Nullable<NaiveDateTimeObj | string>,
) => datetimeObjToISOString(obj);
